import { FormControl } from "@ecco/ui/form-control";
import { FormErrorMessage } from "@ecco/ui/form-error";
import { FormLabel } from "@ecco/ui/form-label";
import { Input } from "@ecco/ui/input";
import { Field } from "formik";
import { styles } from "./baseFormStyles";
import type { SingleFieldProps } from "./baseFormsValidations";

export const CountryCodeField = ({
    error,
    isInvalid,
    header,
    id,
    name,
    testId,
}: SingleFieldProps) => {
    return (
        <FormControl width={120} isInvalid={isInvalid} pointerEvents="none">
            <FormLabel htmlFor={id} sx={{ ...styles.formLabel, mr: 0, w: "auto" }}>
                {header}
            </FormLabel>
            <Field
                as={Input}
                id={id}
                name={name ?? id}
                type="text"
                sx={styles.countryCodeField}
                width={100}
                tabIndex={-1}
                aria-hidden="true"
                data-testid={testId}
            />
            <FormErrorMessage>{error}</FormErrorMessage>
        </FormControl>
    );
};

export default CountryCodeField;
